import React, { useContext, useEffect, useState } from "react";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

// Custom.
import { VoAuth } from "@vocollege/app";
import LayoutNaked from "containers/Layout/LayoutNaked";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import LogoSvg from "@vocollege/theme/dist/images/vocollege.svg";
import { VoLoader } from "@vocollege/components";
import { VoAppContext } from "services/GlobalState";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3),
      textAlign: "center",
      color: theme.palette.text.secondary,
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: 400,
    },
    row: {
      padding: theme.spacing(2),
    },
    logoWrapper: {
      display: "inline-block",
      height: 80,
      minWidth: "200px",
    },
  })
);

function Login() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const { dispatch } = useContext<any>(VoAppContext);

  // Methods.

  const login = () => {
    const loginUrl = VoAuth.getAppLoginUrl;
    window.location.href = loginUrl;
  };

  // Effects.

  useEffect(() => {
    dispatch({
      key: "hideHeader",
      values: true,
    });
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (VoAuth.currentUser) {
    window.location.href = "/";
    return <span></span>;
  }

  return (
    <LayoutNaked variant="centered">
      {loading && <VoLoader />}
      {!loading && (
        <Paper elevation={10} className={classes.paper}>
          <div className={classes.row}>
            <div className={classes.logoWrapper}>
              <img src={LogoSvg} alt={process.env.REACT_APP_NAME} />
            </div>
          </div>
          <div className={classes.row}>
            <Typography variant="h5">{process.env.REACT_APP_NAME}</Typography>
          </div>
          <div className={classes.row}>
            <Button onClick={login} variant="contained" color="secondary">
              {I18n.get.auth.actions.clickToSingIn}
            </Button>
          </div>
        </Paper>
      )}
    </LayoutNaked>
  );
}

export default Login;
